import { appstr } from "../utils/appstr";
import { QDropDown } from "./QDropDown";
import { QListMgr } from "./QListMgr";
import { QOptionArray } from "./QOptionArray";

export class QToggleDropDown extends QDropDown {
  constructor() {
    super();
    this.fObjectKey = "";
  }

  BuildBasicOptions(toggleSetList) {
    this.fToggleSetList = toggleSetList;
    var ddArray = new QOptionArray();
    if (toggleSetList == null) return ddArray;
    var activeList = this.fActiveSourceList;
    for (var i = 0; i < toggleSetList.length; i++) {
      var aToggleSet = toggleSetList[i];
      var toggleOptions = aToggleSet.fOptions;
      var label = aToggleSet.fLabel;
      var doLookup = aToggleSet.fLookup;

      if (label != null) {
        var labelO = ddArray.addLabelOption(label);
        labelO.fHasDivider = aToggleSet.fHasDivider;
      }

      for (var j in toggleOptions) {
        var aOption = toggleOptions[j];
        var oName = aOption;
        if (doLookup && aOption.length > 0) oName = appstr(aOption);
        var isToggled = aToggleSet.fFilterOut
          ? activeList.indexOf(aOption) === -1
          : activeList.indexOf(aOption) > -1;
        var curOption = ddArray.addToggleOption(
          oName,
          isToggled,
          aToggleSet.fDisabled,
          aToggleSet.fIsToggle
        );
        curOption.fCmdCode = "basicToggle-" + aOption;
        curOption.fButtonIndex = i;
      }
    }
    return ddArray;
  }

  //============================================================
  InitToggleDropDown(
    WSMgr,
    parentPanel,
    header,
    optionsList,
    index,
    sourceData,
    availableList,
    listID,
    syncKey,
    srcElement,
    matchZLayer
  ) {
    this.fListID = listID;
    this.InitDropDown(WSMgr, parentPanel, header, optionsList, index, matchZLayer, srcElement);
    this.fListMgr = new QListMgr();
    this.fListMgr.CreateBinList(this, listID, sourceData, availableList, syncKey);
  }

  DoAfterToggle(aCmd) {
    this.fParentPanel.ExecuteCommand(aCmd);
  }

  DoUpdateFramelessToggleArray() {
    var listMgr = this.fListMgr;
    var ddList = listMgr.GetListByID(this.fListID);
    var allOptions = ddList.fAvailableList;
    var dataSource = ddList.fDataSource;
    var optionArray = new QOptionArray();
    for (var i = 0; i < allOptions.length; i++) {
      var optionName = allOptions[i];
      var isToggle = optionName !== appstr("Select All");
      var idx = dataSource.findIndex(
        sourceItem => JSON.stringify(sourceItem) === JSON.stringify(optionName)
      );
      var isToggled = this.fFilterIn ? idx === -1 : idx > -1;
      var anOption = optionArray.addToggleOption(
        optionName,
        isToggled,
        false,
        isToggle,
        optionName[this.fObjectKey]
      );
      if (this.fOptionsList && this.fOptionsList.fArray) {
        // get reference to previous option array
        // persist divider for toggle options
        var previousOptions = this.fOptionsList.fArray;
        anOption.fHasDivider = previousOptions[i] && previousOptions[i].fHasDivider;
      }
    }
    this.UpdateFramelessDropDown(null, optionArray);
  }
}
